<template>
  <div class="confirm-dialog-overlay" @click.self="$emit('cancel')">
    <div class="confirm-dialog">
      <div class="dialog-icon" :class="`icon-${type}`">
        <i v-if="type === 'danger'" class="fa fa-exclamation-triangle"></i>
        <i v-else-if="type === 'warning'" class="fa fa-exclamation-triangle"></i>
        <i v-else-if="type === 'success'" class="fa fa-check"></i>
        <i v-else class="icon-info"></i>
      </div>

      <h3 class="dialog-title">{{ title }}</h3>
      <p class="dialog-message">{{ message }}</p>

      <div class="dialog-actions">
        <button @click="$emit('cancel')" class="btn btn-outline">
          Hủy
        </button>
        <button
          @click="$emit('confirm')"
          class="btn"
          :class="`btn-${type}`"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'success', 'warning', 'danger'].includes(value),
    },
    confirmText: {
      type: String,
      default: 'Xác nhận',
    },
  },
  emits: ['confirm', 'cancel'],
};
</script>

<style scoped>
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.confirm-dialog {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.dialog-icon {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
}

.dialog-icon.icon-danger {
  background: #fee;
  color: #e53e3e;
}

.dialog-icon.icon-warning {
  background: #fffaf0;
  color: #dd6b20;
}

.dialog-icon.icon-success {
  background: #f0fff4;
  color: #38a169;
}

.dialog-icon.icon-info {
  background: #ebf8ff;
  color: #3182ce;
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
}

.dialog-message {
  color: #718096;
  margin: 0 0 1.5rem 0;
  line-height: 1.6;
}

.dialog-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
}

.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-outline {
  background: white;
  border: 1px solid #e2e8f0;
  color: #4a5568;
}

.btn-outline:hover {
  background: #f7fafc;
}

.btn-danger {
  background: #e53e3e;
  color: white;
}

.btn-danger:hover {
  background: #c53030;
}

.btn-warning {
  background: #dd6b20;
  color: white;
}

.btn-warning:hover {
  background: #c05621;
}

.btn-success {
  background: #38a169;
  color: white;
}

.btn-success:hover {
  background: #2f855a;
}

.btn-info {
  background: #3182ce;
  color: white;
}

.btn-info:hover {
  background: #2c5282;
}
</style>